import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, Typography } from '@material-ui/core';

const styles = makeStyles({
  forgotPassword: {
    margin: '30px 0 40px',
    display: 'flex',
    justifyContent: 'center',
  },
});

const ForgotPasswordLink: React.FC = () => {
  const classes = styles();

  return (
    <div className={classes.forgotPassword}>
      <Typography>
        <Link to={'/forgot'}>Esqueceu sua senha?</Link>
      </Typography>
    </div>
  );
};

export default ForgotPasswordLink;
